import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config";

export default function SavedPaymentMethods({ onMethodRemoved, onDefaultChanged, methodsChanged }) {
    const [methods, setMethods] = useState([]);
    const [defaultId, setDefaultId] = useState(null);
    const [editNames, setEditNames] = useState({}); // { [pm.id]: string }
    const [editing, setEditing] = useState({}); // { [pm.id]: boolean }
    const [saving, setSaving] = useState({}); // { [pm.id]: boolean }

    useEffect(() => {
        async function fetchMethods() {
            const res = await fetch(`${API_BASE_URL}/api/customer/payment-methods`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            });
            const data = await res.json();
            setMethods(data.payment_methods || []);
            setDefaultId(data.default_payment_method_id); // backend should return this
        }
        fetchMethods();
    }, [methodsChanged]);

    async function handleRemove(id) {
        await fetch(`${API_BASE_URL}/api/customer/payment-methods/${id}`, {
            method: "DELETE",
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        if (onMethodRemoved) onMethodRemoved();
    }

    async function handleSetDefault(id) {
        await fetch(`${API_BASE_URL}/api/customer/payment-methods/${id}/default`, {
            method: "POST",
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        if (onDefaultChanged) onDefaultChanged();
    }

    // Handler to update local edit state
    const handleEditNameChange = (pmId, value) => {
        setEditNames((prev) => ({ ...prev, [pmId]: value }));
    };

    // Handler to start editing
    const handleStartEdit = (pmId, currentName) => {
        setEditing((prev) => ({ ...prev, [pmId]: true }));
        setEditNames((prev) => ({ ...prev, [pmId]: currentName || "" }));
    };

    // Handler to save the new name
    const handleSaveName = async (pmId) => {
        setSaving((prev) => ({ ...prev, [pmId]: true }));
        await fetch(`${API_BASE_URL}/api/customer/payment-methods/${pmId}/name`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ name: editNames[pmId] || "" }),
        });
        setSaving((prev) => ({ ...prev, [pmId]: false }));
        setEditing((prev) => ({ ...prev, [pmId]: false }));
        // Refresh list
        if (onDefaultChanged) onDefaultChanged();
    };

    return (
        <div style={{ maxWidth: 400, margin: "2rem auto" }}>
            <h4>Saved Payment Methods</h4>
            {methods.length === 0 && <div>No saved methods.</div>}
            <ul>
                {methods.map(pm => {
                    let label = pm.custom_name && pm.custom_name.trim()
                        ? pm.custom_name
                        : (pm.card ? `Saved Card ending in **${pm.card.last4}` : "Unknown method");
                    const isEditing = editing[pm.id];
                    return (
                        <li key={pm.id} style={{ marginBottom: 12 }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {isEditing ? (
                                    <>
                                        <input
                                            type="text"
                                            value={editNames[pm.id] !== undefined ? editNames[pm.id] : (pm.custom_name || "")}
                                            onChange={e => handleEditNameChange(pm.id, e.target.value)}
                                            style={{ width: 180, marginRight: 8 }}
                                            placeholder="Payment method name"
                                        />
                                        <button
                                            onClick={() => handleSaveName(pm.id)}
                                            disabled={saving[pm.id]}
                                            style={{ marginRight: 8 }}
                                        >
                                            {saving[pm.id] ? "Saving..." : "Save"}
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <span style={{ minWidth: 180, marginRight: 8 }}>{label}</span>
                                        <button
                                            onClick={() => handleStartEdit(pm.id, pm.custom_name)}
                                            style={{ marginRight: 8 }}
                                        >
                                            Edit Name
                                        </button>
                                    </>
                                )}
                                {pm.id === defaultId && <span style={{ color: "green", marginLeft: 8 }}>(Default)</span>}
                                <button style={{ marginLeft: 12 }} onClick={() => handleRemove(pm.id)}>
                                    Remove
                                </button>
                                {pm.id !== defaultId && (
                                    <button style={{ marginLeft: 8 }} onClick={() => handleSetDefault(pm.id)}>
                                        Set as Default
                                    </button>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}